import { API_VERSIONS, asinzenAdminApi } from "../client/api";

export const logOutAllUsers = () =>
  asinzenAdminApi({})
    .post(`/${API_VERSIONS}/admin/users/logout-all-user`);

export const logOutAllUsersByType = (request: any) =>
  asinzenAdminApi({})
    .post(`/${API_VERSIONS}/admin/users/logout-all-user`, request);

export const getUserInfo = (email: string) =>
  asinzenAdminApi({})
    .get(`/${API_VERSIONS}/admin/users/email/${email}`);